module.exports = __webpack_public_path__ + "img/The Economist NZA briefing story, 2-20-21.pdf";